import Orders from './orders';
import Production from './production';
import Stock from './stock';
import Engineering from './engineering';
import OpOs from './opos';
import Purchases from './purchases';

export default {
  Orders,
  Production,
  Stock,
  Engineering,
  OpOs,
  Purchases,
};
